module.exports = __webpack_public_path__ + "static/media/icone_bloquear_cartao.59677322.svg";